<template>
    <div class="chat-user-card" @click.stop="onShowUserInfo">
        <div class="card-body">
            <head-image :url="cardInfo.headImage" :name="cardInfo.nickName" radius="10%"></head-image>
            <div class="nick-name">
                {{ cardInfo.nickName }}
            </div>
        </div>
        <div class="card-tip">个人名片</div>
    </div>
</template>
<script>
import HeadImage from '../common/HeadImage.vue';

export default {
    name: "chatUserCard",
    components: {
        HeadImage
    },
    props: {
        cardInfo: {
            type: Object
        }
    },
    data() {
        return {}
    },
		methods: {
			onShowUserInfo(e) {
				if (!this.cardInfo || !this.cardInfo.userId) {
					this.$message.warning('个人名片信息不完整');
					return;
				}
				const pos = this.buildCardPos(e);
				this.$http({
					url: `/user/find/${this.cardInfo.userId}`,
					method: 'get'
				}).then(user => {
					this.$eventBus.$emit("openUserInfo", this.mergeUserInfo(user), pos);
				}).catch(error => {
					console.warn('刷新个人名片资料失败:', error);
					this.$eventBus.$emit("openUserInfo", this.buildFallbackUser(), pos);
				})
			},
        buildCardPos(e) {
            return {
                x: e.x + 30,
                y: e.y
            }
        },
        buildFallbackUser() {
            const card = this.cardInfo || {};
            const friend = this.friendStore && card.userId ? this.friendStore.findFriend(card.userId) : null;
            const displayName = card.nickName || (friend && (friend.showNickName || friend.nickName || friend.userName)) || card.userName || '个人名片';
            const headImage = card.headImage || (friend && friend.headImage) || '';
            return {
                ...(friend || {}),
                id: card.userId,
                nickName: displayName,
                showNickName: displayName,
                userName: card.userName || (friend && friend.userName) || '',
                headImage,
                headImageThumb: headImage
            }
        },
        mergeUserInfo(user) {
            const fallbackUser = this.buildFallbackUser();
            const nextUser = {
                ...fallbackUser,
                ...(user || {})
            };
            nextUser.nickName = nextUser.nickName || nextUser.showNickName || fallbackUser.nickName;
            nextUser.showNickName = nextUser.showNickName || nextUser.nickName || fallbackUser.showNickName;
            nextUser.headImageThumb = nextUser.headImageThumb || nextUser.headImage || fallbackUser.headImageThumb;
            nextUser.headImage = nextUser.headImage || nextUser.headImageThumb || fallbackUser.headImage;
            return nextUser;
        }
    }

}
</script>
<style scoped lang="scss">
.chat-user-card {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background: var(--im-control-soft-bg);
    border-radius: 6px;
    padding: 10px 12px;
    height: 90px;
    width: min(100%, 200px);
    max-width: 100%;
    cursor: pointer;
    border: 1px solid var(--im-control-border);
    transition: border-color 0.2s ease, background-color 0.2s ease;
    position: relative;
    overflow: hidden;
    text-align: left;
    box-sizing: border-box;

    &:hover {
        border-color: rgba(var(--im-primary-rgb), 0.2);
        background: rgba(var(--im-primary-rgb), 0.06);
    }

    .card-body {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 10px;
        border-bottom: 1px solid rgba(var(--im-black-rgb), 0.06);
        padding-bottom: 8px;

        .nick-name {
            flex: 1;
            min-width: 0;
            font-weight: 600;
            font-size: 15px;
            color: var(--im-text-color-primary);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.3;
        }
    }

    .card-tip {
        margin-top: 6px;
        color: var(--im-text-color-light);
        font-size: 12px;
        text-align: left;
        font-weight: 500;
    }
}
</style>
